import React from 'react';
import { Star, StarHalf } from '../icons';

function StarRating({ rating, size = 16 }) {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.5;

  for (let i = 0; i < fullStars; i++) {
    stars.push(<Star key={i} size={size} className="star-filled" />);
  }
  if (hasHalf) {
    stars.push(<StarHalf key="half" size={size} className="star-filled" />);
  }
  const remaining = 5 - fullStars - (hasHalf ? 1 : 0);
  for (let i = 0; i < remaining; i++) {
    stars.push(<Star key={`empty-${i}`} size={size} className="star-empty" />);
  }

  return <div className="star-rating">{stars}</div>;
}

export default StarRating;
